import React, { useState, useRef, useEffect } from 'react';
// import styles from '../../styles/CurrencyPreview.module.scss';
import { Text } from '@shopify/polaris';

const CurrencyPreview = ({
                             priceFormat,
                             displayFlag,
                             flagStyle = 0,
                             displayBorder = 0,
                             borderColor = '#d8d8d8',
                             backgroundColor = '#ffffff',
                             backgroundHoverColor = '#f6f6f7',
                             textColor = '#202223',
                             textHoverColor = '#008060',
                             selectedCurrencies = [],
                             currencies = [],
                             removeDecimals ,
                             priceRounding,
                             borderRadius = '8px',
                             fontSize = ''
                         }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState(selectedCurrencies[0] || '');
    const dropdownRef = useRef(null);

    const getCurrencyInfo = (code) => {
        const currency = currencies.find(c => c.value === code.value);
        return {
            name: currency?.label || '',
            flag: currency?.countryCode || '',
            value:currency?.value || ""
        };
    };

    const formatPrice = (price) => {
        let formattedPrice = price;
        if (removeDecimals) {
            formattedPrice = Math.floor(price);
        } else if (priceRounding) {
            // Round to nearest whole number
            formattedPrice = Math.round(price);
        } else {
            // Keep original price with 2 decimal places
            formattedPrice = Math.round(price * 100) / 100;
        }

        return formattedPrice;
    };

    const handleSelectClick = (e) => {
        e.stopPropagation();
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleCurrencySelect = (currencyCode) => {
        setSelectedCurrency(currencyCode);
        setIsDropdownOpen(false);
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (selectedCurrencies.length > 0 && !selectedCurrency) {
            setSelectedCurrency(selectedCurrencies[0]);
        }
    }, [selectedCurrencies, selectedCurrency]);

    const previewStyle = {
        border: displayBorder.value === 0 ? `1px solid ${borderColor}` : 'none',
        '--background-color': backgroundColor,
        '--background-hover-color': backgroundHoverColor,
        '--text-color': textColor,
        '--text-hover-color': textHoverColor,
        '--border-color': borderColor,
        borderRadius: borderRadius || '8px',
        ...(fontSize ? { fontSize } : {}),
        transition: 'all 0.3s ease',
    };

    const currencyInfo = getCurrencyInfo(selectedCurrency);
    const formattedPrice = formatPrice(99.99);
    return (
        <div className="previewContainer">
            <Text variant="span" fontWeight='semibold'>Preview</Text>
            <div className={"previewBox"}>
                <div className={"previewSelect"} onClick={handleSelectClick} style={previewStyle}>
                    <div className={"previewContent"} >
                        {
                            
                            displayFlag.value === 0 && (
                            <div className={`flagPreview ${flagStyle?.value === 1 ? "circleFlag" : ''}`}>
                                <img
                                    src={`https://cdn.shopify.com/s/files/1/0601/7908/7425/files/${currencyInfo.flag?.toLowerCase()}-flag.jpg`}
                                    alt=""
                                    className={"flagImage"}
                                />
                            </div>)
                        }
                        <div className={"currencyInfo"}>
                            <span className={"currencyName"}>{currencyInfo.value}</span>
                         
                        </div>
                    </div>
                    <div className={"selectArrow"}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className={"pricePreview"}>
                    {priceFormat.value === 0 ? (
                        <>
                            ${formattedPrice} <span className={"currencyCode"}>{selectedCurrency?.value
                            }</span>
                        </>
                    ) : (
                        `$${formattedPrice}`
                    )}
                </div>
                </div>
                {isDropdownOpen && selectedCurrencies.length > 1 && (
                    <div className={"previewDropdown"} ref={dropdownRef}>
                        {selectedCurrencies
                            .filter(code => code !== selectedCurrency)
                            .map((code) => {
                                const info = getCurrencyInfo(code);
                                return (
                                    <div
                                        key={code}
                                        className={"previewDropdownItem"}
                                        onClick={() => handleCurrencySelect(code)}
                                        style={previewStyle}
                                    >
                                        {displayFlag.value === 0 && (
                                            <div className={`flagPreview ${flagStyle.value === 1 ? "circleFlag" : ''}`}>
                                                <img
                                                    src={`https://cdn.shopify.com/s/files/1/0601/7908/7425/files/${info.flag.toLowerCase()}-flag.jpg`}
                                                    alt=""
                                                    className={"flagImage"}
                                                />
                                            </div>
                                        )}
                                        <div className={"currencyInfo"}>
                                            <span className={"currencyName"}>{code.value}</span>
                                            {priceFormat === 0 && (
                                                <span className={"currencySymbol"}>{code}</span>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CurrencyPreview;
